<template>
  <form method="post">
    <div class="col-md-11 p-h-xs" >
      <div class="form-group">
        <textarea v-model="notification_content" type="text"  name="notification_content" class="col-md-12" placeholder="Content goes here.. " ></textarea>
        <ladda-button
          class="btn btn-sm btn-success col-md-2"
          type="submit"
          :click="saveContents">
          Save
        </ladda-button>
        <ladda-button
          class="btn btn-sm btn-danger col-md-2"
          type="submit"
          :click="resetContents">
          Reset
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { http } from 'utils'
import { handleServerErrors } from 'utils/http'

export default {
  props: [
    'updatedValue',
    'updatedValueWithPlaceHolders',
    'method',
    'textTemplateId',
    'notificationName',
    'messageKey'
  ],
  data () {
    return {
      notification_content: this.updatedValueWithPlaceHolders
    }
  },

  methods: {
    saveContents () {
      return this.validate()
        .then(() => {
          const params = {
            method: this.method,
            messageKey: this.messageKey,
            textContent: this.notification_content,
            notificationName: this.notificationName
          }

          return http.post(`text-notification-content`, params).then((response) => {
            if (response.data === 1) {
              this.$parent.handleAddManagerCallback()
            } else {
              throw new Error('Error saving template')
            }
          })
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            handleServerErrors(error, this.errors)
          } else {
            throw error
          }
        })
    },
    resetContents () { // TODO: merge into one method
      return this.validate()
        .then(() => {
          const params = {
            notificationTemplateId: this.textTemplateId,
            partId: this.messageKey
          }

          return http.post(`text-notification-content-reset`, params).then((response) => {
            if (response.data === 1) {
              this.notification_content = this.messageKey
              this.$parent.handleAddManagerCallback()
            } else {
              throw new Error('Error resetting template')
            }
          })
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            handleServerErrors(error, this.errors)
          } else {
            throw error
          }
        })
    }
  }
}
</script>
